<brightside-web-product-eligibility
  [productCode]="productType"
  (successfulSubmit)="submitAction()"
  [showBackbutton]="true">
</brightside-web-product-eligibility>
